export default __webpack_public_path__ + "static/media/about.091fce30.png";